export default "__VITE_PUBLIC_ASSET__6d6f5b6c__"